import { Link } from "react-router-dom";
import { MessageCircle, AtSign } from "lucide-react";
import { timeAgo, plural } from "@/lib/api";
import VoteButtons from "@/components/VoteButtons";

export default function ThreadCard({ thread, index = 0 }) {
  return (
    <Link to={`/c/${thread.community.slug}/t/${thread.id}`} data-testid={`thread-card-${thread.id}`} style={{ animationDelay: `${index * 50}ms` }}
      className="rise-in flex gap-4 rounded-md border border-[#2A2E37] bg-[#121418] p-4 transition-[transform,border-color] duration-300 hover:-translate-y-0.5 hover:border-white/25">
      <VoteButtons thread={thread} />
      <div className="min-w-0 flex-1">
        <p className="text-xs text-gray-400">
          <span className="font-semibold text-[#FF2E4D]">c/{thread.community.slug}</span> · @{thread.author.username} · {timeAgo(thread.created_at)}
        </p>
        <h3 className="mt-1 text-[15px] font-semibold leading-snug tracking-tight">{thread.title}</h3>
        {thread.body && <p className="mt-1 line-clamp-2 text-sm text-gray-300">{thread.body}</p>}
        <div className="mt-3 flex flex-wrap items-center gap-3 text-xs text-gray-400">
          <span className="flex items-center gap-1"><MessageCircle className="h-3.5 w-3.5" />{plural(thread.comments_count, "comment")}</span>
          {thread.about_username && (
            <span className="flex items-center gap-1 rounded-sm border border-[#2A2E37] bg-[#1C1F26] px-2 py-0.5 font-semibold text-gray-200" data-testid="thread-about-tag">
              <AtSign className="h-3 w-3" />{thread.about_username}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
